import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Provider, Providers } from 'src/models/Provider.interface';
import { ProvidersService } from '../services/providers.service';

@Component({
  selector: 'app-provider-form-modal',
  templateUrl: './provider-form-modal.component.html',
  styleUrls: ['./provider-form-modal.component.css']
})
export class ProviderFormModalComponent {
  providerForm: FormGroup;
  newProvider: any = { name: '', type: '', status: '', id: null };

  constructor(
    public dialogRef: MatDialogRef<ProviderFormModalComponent>,
    private providersService: ProvidersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) {
    this.providerForm = this.formBuilder.group({
      id: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      name: ['', Validators.required],
      type: ['', Validators.required],
      status: ['', Validators.required],
      complexity: ['', Validators.required],
    });
  }

  handleCreateProvider(): void {
    if (this.providerForm.valid) {
      const newProvider: Provider = {
        id: parseInt(this.providerForm.get('id')?.value),
        name: this.providerForm.get('name')?.value,
        type: this.providerForm.get('type')?.value,
        status: this.providerForm.get('status')?.value,
        complexity: this.providerForm.get('complexity')?.value
      };
      this.dialogRef.close(newProvider);
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
